module.exports = __webpack_public_path__ + "static/img/tags-tratativas.1cfa4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tags-tratativas.png
// module id = wm9W
// module chunks = 1